import BossModel from "@/models/BossModel";
import Proposal from "@/models/Proposal/Proposal";
import ProposalSurcharge from "@/models/Proposal/ProposalSurcharge/ProposalSurcharge";
import Agent from "@/models/Agent/Agent";
import Airline from "@/models/Airline/Airline";
import orderBy from "lodash/orderBy";
import Product from "@/models/Proposal/Product/Product";
import Ticket from "@/models/Proposal/Ticket/Ticket";

export default class Cancellation extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/cancellation';

    /**
     *
     * @type {string}
     */
    static entity = 'cancellations';

    static fields() {
		return {
			id: this.number(null).nullable(),
			proposal_id: this.number(null).nullable(),
			invoice_notes: this.attr(null),
			internal_notes: this.attr(null),
			debit_purchase_price: this.number(null).nullable(),
			purchase_price: this.number(null),
			sale_price: this.number(null),
			agent_id: this.number(null).nullable(),
			airline_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			is_customer_visible: this.boolean(null),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            agent: this.belongsTo(Agent, 'agent_id'),
            airline: this.belongsTo(Airline, 'airline_id'),
            products: this.hasMany(Product, 'proposal_cancellation_id'),
            tickets: this.hasMany(Ticket, 'proposal_cancellation_id'),
            surcharges: this.hasMany(ProposalSurcharge, 'proposal_cancellation_id'),
		}
	}

    SaveWithItems(productIds, ticketIds, skipSendingToAgentsIds, surchargeIds) {
        let data = this.Clone();
        data.product_ids = productIds;
        data.ticket_ids = ticketIds;
        data.skip_sending_to_agents_ids = skipSendingToAgentsIds;
        data.surcharge_ids = surchargeIds;

        return this.constructor.api().create(data);
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    update() {
        return this.api().update(this);
    }

    /**
     *
     * @returns {boolean|*}
     */
    Proposal() {
        return this.getRelated('proposal');
    }

    /**
     *
     * @returns {*}
     */
    Lines() {
        return this.getRelated('lines');
    }

    /**
     *
     * @returns {*}
     */
    ProposalSurcharges() {
        return orderBy(this.getRelated('surcharges'), 'id');
    }

    static clearByProposal(proposalId) {
        this.all().forEach(cancellation => {
            if (cancellation.proposal_id === proposalId) {
                cancellation.destroy();
            }
        });
    }
}
